import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GridItem, Grid } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { TruckIcon } from '@yonderland/andes-icons';
import { Box, ConditionalWrapper, Icon, TextAlpha } from '@yonderland/andes-react';
import { useSelector } from 'react-redux';
import { makeGetPriceInformation } from '../../../redux/product/selectors/ProductSelector';
import AsNumeral from '../../../vendors/asNumeral';
const MESSAGE_THRESHOLD = '{THRESHOLD}';
export const FreeDeliveryMessage = ({ freeDeliveryMessage, thresholdFreeDelivery, withGridWrapper = false, }) => {
    var _a, _b, _c;
    const { currency } = useAemConfig();
    const pricing = useSelector(makeGetPriceInformation());
    if (!thresholdFreeDelivery || !freeDeliveryMessage)
        return null;
    const message = pricing && ((_b = (_a = pricing.prices) === null || _a === void 0 ? void 0 : _a.SELL) === null || _b === void 0 ? void 0 : _b.original) >= thresholdFreeDelivery
        ? freeDeliveryMessage.equalOrAboveThreshold
        : freeDeliveryMessage.belowThreshold;
    if (!message.productText)
        return null;
    return (_jsx(ConditionalWrapper, { condition: withGridWrapper, wrapper: children => (_jsx(Grid, { rows: 2, gap: "none", templateColumns: "auto 1fr", children: children })), children: _jsxs(_Fragment, { children: [message.showTruckIcon && (_jsx(GridItem, { row: {
                        start: 1,
                        end: 'span 2',
                    }, children: _jsx(Box, { paddingBlockStart: "0.5", paddingInlineEnd: "2", children: _jsx(Icon, { source: TruckIcon, color: message.fontColor === 'green' ? 'success' : undefined, size: "xs" }) }) })), _jsx(TextAlpha, { color: message.fontColor === 'green' ? 'success' : 'current', variant: "bodyS", strong: true, children: (_c = message.productText) === null || _c === void 0 ? void 0 : _c.replace(MESSAGE_THRESHOLD, `${currency}${AsNumeral.formatAsCurrency(thresholdFreeDelivery)}`) })] }) }));
};
